import { useNavigate, useLocation } from "react-router-dom"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import { routes } from "../utils/routes.config"
import { handleCheckAuth } from "../utils/handleAuth"

const AuthMiddleware = ({ children }: any) => {
    const authUser = handleCheckAuth()
    const navigate = useNavigate()
    const location = useLocation()
    const userData = useSelector((state: any) => state.UserData?.userData)
    const isStoreOwner = userData?.role === "user"
    const hasActivePlan = userData?.hasActivePlan
    const isOnSelectPlan = location.pathname === routes.SELECT_PLAN || location.pathname.startsWith("/plans/select")

    useEffect(() => {
        if (!authUser) {
            navigate(routes.LOGIN)
            return
        }
        if (isStoreOwner && hasActivePlan === false && !isOnSelectPlan) {
            navigate(routes.SELECT_PLAN)
        }
    }, [authUser, isStoreOwner, hasActivePlan, isOnSelectPlan, navigate])

    return children
}

export default AuthMiddleware